const initState = {
    vendors: {},
    fetching: false,
    filters: {}
};

export default initState;
